var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 16.5H11.75C15.5 16.5 17 15 17 11.25V6.75C17 3 15.5 1.5 11.75 1.5H7.25C3.5 1.5 2 3 2 6.75V11.25C2 15 3.5 16.5 7.25 16.5Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.625 9C13.625 11.28 11.78 13.125 9.5 13.125C7.22 13.125 5.83249 10.83 5.83249 10.83M5.83249 10.83H7.6925M5.83249 10.83V12.8925M5.375 9C5.375 6.72 7.205 4.875 9.5 4.875C12.2525 4.875 13.625 7.17 13.625 7.17M13.625 7.17V5.1075M13.625 7.17H11.795",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionReset);
export default __webpack_public_path__ + "static/media/action-reset.7bd94fc70ff8265851121af136d0f058.svg";
export { ForwardRef as ReactComponent };